var _filter, _filter2, _rect, _g, _text, _text2, _path, _path2, _circle, _circle2, _circle3, _circle4, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg10ConnectionEstablished(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 900 450",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "connectedGradA",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#10b981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#059669"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "connectedGradB",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#06b6d4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0891b2"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "streamGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#10b981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#22d3ee"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#06b6d4"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glowConnection",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "shadowConn",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 6,
    stdDeviation: 12,
    floodOpacity: 0.3
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 450,
    fill: "#0f172a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 100,
    r: 3,
    fill: "#34d399"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "100;80;100",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.6;1;0.6",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 120,
    r: 4,
    fill: "#22d3ee"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "120;95;120",
    dur: "2.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 90,
    r: 3,
    fill: "#a78bfa"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "90;70;90",
    dur: "1.8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 110,
    r: 3,
    fill: "#f472b6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "110;85;110",
    dur: "2.2s",
    repeatCount: "indefinite"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 45,
    textAnchor: "middle",
    fill: "#f8fafc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 26,
    fontWeight: "bold"
  }, "\n    \uD83C\uDF89 P2P Connection Established!\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 75,
    textAnchor: "middle",
    fill: "#34d399",
    fontFamily: "system-ui, sans-serif",
    fontSize: 16
  }, "\n    Direct communication between peers\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 220 220 C 350 170, 550 170, 680 220",
    stroke: "url(#streamGrad)",
    strokeWidth: 12,
    fill: "none",
    strokeLinecap: "round",
    filter: "url(#glowConnection)",
    opacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 220 220 C 350 170, 550 170, 680 220",
    stroke: "url(#streamGrad)",
    strokeWidth: 6,
    fill: "none",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 10,
    fill: "#10b981"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.5s",
    repeatCount: "indefinite",
    path: "M 220 220 C 350 170, 550 170, 680 220"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "10;12;10",
    dur: "0.5s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 8,
    fill: "#22d3ee"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.5s",
    path: "M 220 220 C 350 170, 550 170, 680 220"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 10,
    fill: "#06b6d4"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.5s",
    repeatCount: "indefinite",
    path: "M 680 220 C 550 170, 350 170, 220 220"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "10;12;10",
    dur: "0.5s",
    repeatCount: "indefinite"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 8,
    fill: "#34d399"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.5s",
    path: "M 680 220 C 550 170, 350 170, 220 220"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130, 220)",
    filter: "url(#shadowConn)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -90,
    y: -70,
    width: 180,
    height: 140,
    rx: 20,
    fill: "url(#connectedGradA)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: -50,
    width: 140,
    height: 80,
    rx: 10,
    fill: "#064e3b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -40,
    width: 120,
    height: 55,
    rx: 6,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -15,
    r: 15,
    fill: "#059669"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -15,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -15,
    r: 4,
    fill: "#34d399"
  }), /*#__PURE__*/React.createElement("text", {
    y: 55,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "Peer A"), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: -50,
    r: 8,
    fill: "#22c55e"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.5;1",
    dur: "1s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(770, 220)",
    filter: "url(#shadowConn)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -90,
    y: -70,
    width: 180,
    height: 140,
    rx: 20,
    fill: "url(#connectedGradB)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: -50,
    width: 140,
    height: 80,
    rx: 10,
    fill: "#164e63"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -40,
    width: 120,
    height: 55,
    rx: 6,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -15,
    r: 15,
    fill: "#0891b2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -15,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -15,
    r: 4,
    fill: "#22d3ee"
  }), /*#__PURE__*/React.createElement("text", {
    y: 55,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "Peer B"), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: -50,
    r: 8,
    fill: "#22c55e"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.5;1",
    dur: "1s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -18,
    width: 160,
    height: 36,
    rx: 18,
    fill: "#022c22",
    stroke: "#22c55e",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    y: 6,
    textAnchor: "middle",
    fill: "#4ade80",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: "bold"
  }, "\n      \uD83D\uDD12 ENCRYPTED P2P\n    "))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 340)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -200,
    y: -30,
    width: 400,
    height: 60,
    rx: 12,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-130, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -15,
    width: 60,
    height: 30,
    rx: 6,
    fill: "#7c3aed"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "\uD83C\uDFA5 Video")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -15,
    width: 60,
    height: 30,
    rx: 6,
    fill: "#2563eb"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "\uD83C\uDFA4 Audio")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -15,
    width: 60,
    height: 30,
    rx: 6,
    fill: "#0891b2"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "\uD83D\uDCE6 Data")))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 415)"
  }, /*#__PURE__*/React.createElement("text", {
    y: 0,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#22c55e"
  }, "DTLS"), " + ", /*#__PURE__*/React.createElement("tspan", {
    fill: "#22c55e"
  }, "SRTP"), " encryption protects all communication\n    "))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg10ConnectionEstablished);
export default __webpack_public_path__ + "static/media/10-connection-established.89478c43dfe075ad9d653305500c16e3.svg";
export { ForwardRef as ReactComponent };